import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ContextBar } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import { quoteSelectors } from '../../services/redux/features/quote.slice';

export const HeaderTitle: FunctionComponent = () => {
  const quoteReference = useSelector(quoteSelectors.selectQuoteReference);
  const isValidStep = /^\/form\/[1-4]/.test(window.location.pathname);
  const [showHeaderTitle, setShowHeaderTitle] = useState(true);
  const headerTitleHideBreakpoint = 1200;

  let contextBarLabel = '';

  if (quoteReference && isValidStep) {
    contextBarLabel = `${t('app:header:headerTitleWithQuoteReference')} ${quoteReference}`;
  } else if (showHeaderTitle) {
    contextBarLabel = t('app:header:headerTitle');
  }

  useEffect(() => {
    const handleResize = () => {
      setShowHeaderTitle(window.innerWidth >= headerTitleHideBreakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!contextBarLabel) return null;
  return (
    <ContextBar.SiteNav>
      <ContextBar.SiteNav.Item label={contextBarLabel} noLink title />
    </ContextBar.SiteNav>
  );
};
